<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaStavkaBase"
};
</script>

<style scoped>

</style>
